import React, { useMemo } from "react";
import { NavLink, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { ReactComponent as UserIcons } from "./Icons/UserIcons.svg";
import { ReactComponent as DashboardIcon } from "./Icons/DashboardIcon.svg";
import { ReactComponent as Agenda } from "./Icons/Agenda.svg";
import { ReactComponent as Messagerie } from "./Icons/Messagerie.svg";
import { ReactComponent as AttenteIcon } from "./Icons/AttenteIcon.svg";
import { ReactComponent as Annoncespublies } from "./Icons/annoncespublies.svg";
import { ReactComponent as Parametres } from "./Icons/Parametres.svg";

// Icon mapping for dynamic rendering
const ICON_MAP = {
  DashboardIcon: <DashboardIcon />,
  Agenda: <Agenda />,
  Messagerie: <Messagerie />,
  AttenteIcon: <AttenteIcon />,
  Annoncespublies: <Annoncespublies />,
  Parametres: <Parametres />,
};

// Centralized menu configuration - single source of truth
const MENU_CONFIG = [
  { id: 'dashboard', name: 'Tableau de bord', link: '/dashboard', icon: 'DashboardIcon' },
  { id: 'agenda', name: 'Agenda', link: '/prouser/agenda', icon: 'Agenda' },
  { id: 'messagerie', name: 'Messagerie', link: '/prouser/messagerie', icon: 'Messagerie' },
  { id: 'mes-dossiers', name: 'Mes Dossiers', link: '/prouser/mes-dossiers', icon: 'Annoncespublies', devOnly: true },
  { id: 'signer-docs', name: 'Signer des documents', link: '/prouser/sigmer-des-documents', icon: 'Annoncespublies', devOnly: true },
  { id: 'annonces-pub', name: 'Annonces publiées', link: '/prouser/annoncespublies', icon: 'Annoncespublies' },
  { id: 'annonces-att', name: 'Annonces en attente', link: '/prouser/annoncesenattente', icon: 'AttenteIcon' },
  { id: 'parametres', name: 'Paramètres entreprise', link: '/prouser/parametresentreprise', icon: 'Parametres' },
  { id: 'depot', name: 'Dépôt de Comptes', link: '/prouser/depot-comptes', icon: 'AttenteIcon', devOnly: true },
];
 

export default function SideBar({ menuOpen = false, setMenuOpen = () => {} }) {
  const currentUserData = useSelector((state) => state.authentication.user);
  const isDev = process.env.REACT_APP_PRO_URL !== 'https://app.busyplace.fr/';

  // Filter menu items based on environment - single source of truth
  const menuItems = useMemo(() => {
    return MENU_CONFIG.filter(item => {
      if (item.devOnly && !isDev) return false;
      return true;
    });
  }, [isDev]);
  return (
    <>
      {/* <div className="xl:max-w-[327px] max-w-full w-full xl:max-h-[760px] h-full xl:pb-14 bg-white rounded-[20px] sideShadow"> */} 

      <div className={`xl:max-w-[327px] max-w-full xl:relative w-full xl:max-h-[930px] h-full xl:pb-14 bg-white rounded-[20px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] ${menuOpen ? "transition ease-in-out delay-150 absolute left-0 right-0 top-0 xl:z-[9] z-[999] xl:h-full h-[100vh] overflow-y-auto" : "xl:block hidden transition ease-in-out delay-150"}`}> 
     
        <div className="flex items-center xl:justify-center justify-between px-4 py-3">
          <Link to="/prouser/profile" className="flex-1 min-w-0">
            <div className="flex xl:flex-col flex-row justify-center items-center gap-3 xl:pt-2 pt-0">
              {/* <UserIcons /> `${process.env.REACT_APP_API_URL}uploads/${currentUserData?.UserProDetails?.details?.profile_image}` */}

              {currentUserData &&
                currentUserData.data &&
                currentUserData.data.profile_image ? (
                <img
                src={currentUserData?.data?.profile_image}
                
                  alt={currentUserData?.data?.profile_image}
                  className="w-[30px] h-[30px] xl:w-[70px] xl:h-[70px]"
                />
              ) : (
                <UserIcons />
              )}
              
             

                <h3 className="text-sm sm:text-base text-primary font-semibold truncate max-w-[200px] xl:max-w-full xl:text-center">
                  {currentUserData &&
                    currentUserData.UserProDetails &&
                    currentUserData.UserProDetails.society
                    ? currentUserData.UserProDetails.society.company_name
                    : " "}
                </h3>
            </div>
          </Link>

        </div>

        <div className="xl:mt-2 mt-3">
          <ul>
            {menuItems.map((item) => (
              <NavLink
                key={item.id}
                to={item.link}
                className="mainLi flex items-center gap-3 my-1 py-2.5 mr-2 sm:mr-4 rounded-e-full pl-4 sm:pl-6 text-thBlack hover:text-white transition-all duration-200"
                onClick={() => setMenuOpen(false)}
              >
                <span className="sidebar-Icon flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6">
                  {ICON_MAP[item.icon]}
                </span>
                <span className="text-sm sm:text-base font-normal whitespace-nowrap">
                  {item.name}
                </span>
              </NavLink>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

SideBar.propTypes = {
  menuOpen: PropTypes.bool,
  setMenuOpen: PropTypes.func,
};
